var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check_circle",
    "data-name": "Check Circle",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.338,12.885l-.649-.636a.143.143,0,0,0-.1-.042h0a.137.137,0,0,0-.1.042l-4.5,4.321-1.638-1.561a.148.148,0,0,0-.207,0l-.657.626a.136.136,0,0,0,0,.2L12.545,17.8a.667.667,0,0,0,.432.2.7.7,0,0,0,.428-.193h0l4.933-4.725A.145.145,0,0,0,18.338,12.885Z",
    transform: "translate(-3.53 -4.228)",
    fill: "#05a54f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.875,4.385a6.488,6.488,0,1,1-4.59,1.9,6.447,6.447,0,0,1,4.59-1.9m0-1.01a7.5,7.5,0,1,0,7.5,7.5,7.5,7.5,0,0,0-7.5-7.5Z",
    fill: "#05a54f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.01666657d2585d9dea87ac5ef359a0d3.svg";
export { ForwardRef as ReactComponent };